/**
 * User role enum
 * Defines the available user roles in the application
 */
export enum UserRole {
  TRAVELLER = 'traveller',
  SENDER = 'sender',
  NONE = ''
}

/**
 * Helper functions for role conversions
 */

/**
 * Look up the string role_id from defaultRoles (fetched from /user/getDefaultRoles).
 * Falls back to matching by name (case-insensitive).
 */
export const getRoleIdFromDefaultRoles = (
  role: UserRole,
  defaultRoles: { id: string; name: string }[]
): string => {
  const match = defaultRoles.find((r) => {
    const n = r.name.toLowerCase();
    if (role === UserRole.TRAVELLER) return n === 'traveller' || n === 'traveler';
    if (role === UserRole.SENDER) return n === 'sender';
    return false;
  });
  if (!match) throw new Error(`Role not found in defaultRoles: ${role}`);
  return match.id;
};

export const toggleRole = (currentRole: UserRole): UserRole => {
  return currentRole === UserRole.SENDER ? UserRole.TRAVELLER : UserRole.SENDER;
};

/**
 * Normalizes any backend role string variant to the UserRole enum.
 * Handles "traveler" (single-l) -> UserRole.TRAVELLER, "sender" -> UserRole.SENDER.
 * Returns undefined for unrecognized values.
 */
export const normalizeRole = (raw: string | undefined): UserRole | undefined => {
  if (!raw) return undefined;
  const lower = raw.toLowerCase();
  if (lower === UserRole.TRAVELLER || lower === 'traveler') return UserRole.TRAVELLER;
  if (lower === UserRole.SENDER) return UserRole.SENDER;
  return undefined;
};
